/**
 * 婚姻状况枚举
 */
export default Object.freeze([
    '未婚',
    '已婚',
    '离异',
    '丧偶',
])